import { render, staticRenderFns } from "./bgdRecharge.vue?vue&type=template&id=ac733f5e&scoped=true&"
import script from "./bgdRecharge.vue?vue&type=script&lang=js&"
export * from "./bgdRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac733f5e",
  null
  
)

export default component.exports